export default {
  NAME: 'production',
  API_URL: 'https://api.examiz.com'
}